<div style="padding: 0 5%">
  <div class="container" [ngSwitch]="mode">
    <div *ngSwitchCase="'form'">
      <app-template [title]="'Result Finalize'">
        <div class="info">
          <div class="single">
            <div>
              <p>
                Name. : <b>{{ patient[0]?.first_name }}</b>
              </p>
              <p>
                Sex. : <b>{{ patient[0]?.sex }}</b>
              </p>
              <p>
                Age. : <b>{{ patient[0]?.age }}</b>
              </p>
              <p>
                Mobile : <b>{{ patient[0]?.mobile }}</b>
              </p>
            </div>
          </div>
          <div class="mob">
            <button
              *ngIf="!isSaveLoading"
              [disabled]="stateForm.invalid"
              (click)="onSubmit(e)"
              style="width: 80px"
              mat-raised-button
              color="primary"
            >
              Finalise
            </button>
            <button
              *ngIf="!isSaveLoading"
              [disabled]="stateForm.invalid"
              (click)="Submit(e)"
              mat-raised-button
              color="primary"
              style="margin-left: 20px"
            >
              Save
            </button>
            <button
              *ngIf="isSaveLoading"
              [disabled]="stateForm.invalid"
              (click)="onSubmit(e)"
              style="width: 80px"
              mat-raised-button
              color="primary"
            >
              <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            </button>
            <button
              (click)="backs()"
              mat-raised-button
              color="primary"
              style="margin-left: 20px"
            >
              Back
            </button>
            <!-- <button
              (click)="openFinalize()"
              mat-raised-button
              color="primary"
              style="margin-left: 20px"
            >
              Select Finalizer and Initializer
            </button> -->
          </div>
        </div>
        <div class="data">
          <div *ngIf="isLoading" style="margin-top: 50px" class="spinner">
            <mat-spinner></mat-spinner>
          </div>
          <table *ngIf="!isLoading" style="width: 100%">
            <tr class="back">
              <th>Date</th>
              <th>Finalized</th>
              <th>Service</th>
              <th>Name</th>
              <th>
                <!-- <button  mat-raised-button color="basic">
                              Clear All
                            </button> -->
              </th>
            </tr>
            <tr class="td" *ngFor="let item of data" style="cursor: pointer">
              <td>
                {{ item.result_date | date }}<br />
                <b>{{ item.result_time }}</b>
              </td>
              <td *ngIf="item.is_finalized == 'N'">{{ item.is_finalized }}</td>
              <td *ngIf="item.is_finalized == 'Y'">
                <img
                  style="width: 30px; height: 30px"
                  src="assets/icons/done.gif"
                  alt=""
                />
              </td>
              <td *ngIf="item.is_finalized == 'N'">{{ item.service_name }}</td>
              <td
                style="background-color: green; color: white"
                *ngIf="item.is_finalized == 'Y'"
              >
                {{ item.service_name }}
              </td>
              <td>{{ item.patient_name }}</td>
              <td>
                <button
                  (click)="addRecord(item)"
                  mat-raised-button
                  color="primary"
                >
                  View Result
                </button>
              </td>
            </tr>
          </table>
        </div>
      </app-template>
    </div>
    <div class="wizwig" *ngSwitchCase="'wiz'">
      <app-template [title]="'Format Result'">
        <button
          class="button"
          mat-raised-button
          color="primary"
          [matMenuTriggerFor]="menu"
          style="margin-left: 30px; width: 150px"
        >
          View Clinical History
        </button>
        <mat-menu #menu="matMenu" style="width: 400px">
          <div style="padding: 20px">
            {{ clinicalHistory }}
          </div>
        </mat-menu>
        <div class="form">
          <div
            id="print-section"
            style="display: none; width: 500px; margin: auto"
            [innerHTML]="Template_Text"
          ></div>
          <div class="space"></div>
          <form [formGroup]="stateForm" (ngSubmit)="Submit($event)">
            <!-- <quill-editor formControlName="formatstr" [styles]="{height: '300px'}"></quill-editor> -->
            <angular-editor
              [config]="editorConfig"
              [placeholder]="'Enter text here...'"
              formControlName="formatstr"
            ></angular-editor>
          </form>
          <div class="errorMessage">
            <div *ngIf="Errors" class="error">
              <p>{{ Errors }}</p>
            </div>
          </div>
          <button
            (click)="back()"
            type="button"
            class="create"
            mat-raised-button
            color="primary"
          >
            Back
          </button>
          <button
            *ngIf="!isSaveLoading"
            (click)="done()"
            type="button"
            class="create"
            mat-raised-button
            color="primary"
          >
            OK
          </button>
          <button
            *ngIf="isSaveLoading"
            (click)="done()"
            type="button"
            class="create"
            mat-raised-button
            color="primary"
          >
            <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
          </button>
          <div class="space"></div>
        </div>
      </app-template>
    </div>
  </div>
</div>
